import {Inject, Injectable, InjectionToken} from "@angular/core";
import {WINDOW_LISTENER_TOKEN, WindowHostListenerService} from "./window.host.listener.service";

export let DOCUMENT_SIZE_DETECTOR_TOKEN = new InjectionToken("doc.size.detector");

// dont use injectable doc - the generic @Inject(DOCUMENT)
// this serive is responsible for sizing..

@Injectable()
export class DocumentSizeDetector{

	public lastWidth;
	public lastHeight;

	public lastScrollWidth;
	public lastScrollHeight;

	constructor(@Inject(WINDOW_LISTENER_TOKEN ) private win:WindowHostListenerService){
		this.lastHeight=this.getHeight(false);
		this.lastWidth=this.getWidth(false);

		this.lastScrollHeight=this.getHeight(true);
		this.lastScrollWidth=this.getWidth(true);
	}

	// not used
	// public getHeightObservable():Observable<{withScroll:number; noScroll:number}>{
	// 	return this.win.getObservable(WindowEvent.resize).pipe(filter(()=>{
	// 		let curr=this.getHeight(false);
	// 		let currScroll=this.getHeight(true);
	// 		if ((curr !== this.lastHeight) || (currScroll !== this.lastHeight)){
	// 			this.lastHeight=curr;
	// 			this.lastScrollHeight=currScroll;
	// 			return true;
	// 		}else{
	// 			return false;
	// 		}
	// 	}),map(x=>{return {withScroll:this.getHeight(true),noScroll:this.getHeight(false)};}),);
	// }
	//

	// not used
	// public getWidthObservable():Observable<{withScroll:number; noScroll:number}>{
	// 	return this.win.getObservable(WindowEvent.resize).pipe(filter(()=>{
	// 		let currWidth=this.getWidth(false);
	// 		let currScrollWidth=this.getWidth(true);
	// 		if ((currWidth !== this.lastWidth) || (currScrollWidth !== this.lastScrollWidth)){
	// 			this.lastWidth=currWidth;
	// 			this.lastScrollWidth=currScrollWidth;
	// 			return true;
	// 		}else{
	// 			return false;
	// 		}
	// 	}),map(x=>{return {withScroll:this.getWidth(true),noScroll:this.getWidth(false)};}),);
	// }

	public getWidth(considerScroll:boolean) {
		if (considerScroll){
			return Math.max(
				document.body.scrollWidth,
				document.documentElement.scrollWidth,
				document.body.offsetWidth,
				document.documentElement.offsetWidth,
				document.documentElement.clientWidth
			);
		}else{
			return Math.max(
				document.body.offsetWidth,
				document.documentElement.offsetWidth,
				document.documentElement.clientWidth
			);
		}

	}

	public getHeight(considerScroll:boolean) {
		if (considerScroll){
			return Math.max(
			document.body.scrollHeight,
			document.documentElement.scrollHeight,
			document.body.offsetHeight,
			document.documentElement.offsetHeight,
			document.documentElement.clientHeight);
		}else{
			return Math.max(
				document.body.offsetHeight,
				document.documentElement.offsetHeight,
				document.documentElement.clientHeight);
		}
	}
}
